export default "__VITE_ASSET__DxcXOEX6__"